import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Mail, Phone, Clock, MapPin } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground pt-16 pb-32 md:pb-16">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="font-heading text-3xl font-medium tracking-tight">
              Lumière
            </Link>
            <p className="mt-4 text-primary-foreground/70 leading-relaxed">
              Comida fresca, ingredientes de calidad y sabor que te hace volver.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-primary-foreground/20 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-primary-foreground/20 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-primary-foreground/20 transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-sm font-medium tracking-wide uppercase mb-6">Navegación</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/menu" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Ver menú
                </Link>
              </li>
              <li>
                <Link to="/ubicaciones" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Ubicaciones
                </Link>
              </li>
              <li>
                <Link to="/catering" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Catering y eventos
                </Link>
              </li>
              <li>
                <Link to="/panel" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Panel (Demo)
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-medium tracking-wide uppercase mb-6">Contacto</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-accent mt-0.5" />
                <div>
                  <p className="text-primary-foreground/70">Pedidos</p>
                  <p className="font-medium">81 1234 5678</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-accent mt-0.5" />
                <div>
                  <p className="text-primary-foreground/70">Email</p>
                  <p className="font-medium">hola@lumiere.mx</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-accent mt-0.5" />
                <div>
                  <p className="text-primary-foreground/70">Horario</p>
                  <p className="font-medium">7:00 AM - 11:00 PM</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-medium tracking-wide uppercase mb-6">Legal</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Términos y condiciones
                </a>
              </li>
              <li>
                <a href="#" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Política de privacidad
                </a>
              </li>
              <li>
                <a href="#" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Política de cookies
                </a>
              </li>
              <li>
                <a href="#" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-primary-foreground/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-primary-foreground/50">
              © 2024 Lumière. Todos los derechos reservados.
            </p>
            <p className="text-sm text-primary-foreground/50">
              Hecho con ingredientes frescos y código limpio.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
